import { render, staticRenderFns } from "./AgeTechServiceModify.vue?vue&type=template&id=91d7a386"
import script from "./AgeTechServiceModify.vue?vue&type=script&lang=js"
export * from "./AgeTechServiceModify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports